'use strict';

var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var jsxRuntime = require('react/jsx-runtime');

var i=({label:t="",color:l="light_blue",className:r,...o})=>{let n=r||"",p=l==="light_blue"?"primary":"secondary";return t!=""?jsxRuntime.jsx("span",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-tag ${p} ${n}`),...o,children:t}):jsxRuntime.jsx(jsxRuntime.Fragment,{})},g=i;

exports.a = g;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-KFOM4RNK.js.map